// statusCards.js
import React from "react";
import { CircularProgress, Box } from "@mui/material";

export default function StatusCards({
  dashboardData,
  setDashboardData,
  userData,
}) {
  const isAdmin = userData?.isAdmin === true; // true or false
  // Show loader if data is not yet available
  if (!dashboardData || !dashboardData.overview) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="150px"
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <div className="status-cards-container">
      {/* 1. Orders Card */}
      <div
        className="stat-card"
        style={{ borderLeftColor: "var(--primary-color)" }}
      >
        <div className="stat-card-header">
          <div className="stat-card-title">Orders (Today)</div>
          <i className="fas fa-shopping-cart stat-card-icon"></i>
        </div>
        <div className="stat-card-value">
          {dashboardData.overview.todayOrders}
        </div>
        {isAdmin && (
          <div className="stat-card-footer">
            <span>Total</span>
            <span className="change positive">
              {dashboardData.overview.totalOrders}
            </span>
          </div>
        )}
      </div>

      {/* 2. Revenue Card */}
      <div
        className="stat-card"
        style={{ borderLeftColor: "var(--success-color)" }}
      >
        <div className="stat-card-header">
          <div className="stat-card-title">Revenue (Today)</div>
          <i className="fas fa-dollar-sign stat-card-icon"></i>
        </div>
        <div className="stat-card-value">
          ₹{dashboardData.overview.todayRevenue}
        </div>
        {isAdmin && (
          <div className="stat-card-footer">
            <span>Total</span>
            <span className="change positive">
              ₹{dashboardData.overview.totalRevenue}
            </span>
          </div>
        )}
      </div>

      {/* 3. Menu Items Card */}
      <div
        className="stat-card"
        style={{ borderLeftColor: "var(--info-color)" }}
      >
        <div className="stat-card-header">
          <div className="stat-card-title">Total Menu Items</div>
          <i className="fas fa-utensils stat-card-icon"></i>
        </div>
        <div className="stat-card-value">
          {dashboardData.overview.totalMenuItems}
        </div>
        <div className="stat-card-footer">
          <span>Missing Menus</span>
          <span className="change negative"> 
            {dashboardData.overview.menuMissing}
          </span>
        </div>
      </div>

      {/* 4. Cancelled Orders Card */}
      <div
        className="stat-card"
        style={{ borderLeftColor: "var(--danger-color)" }}
      >
        <div className="stat-card-header">
          <div className="stat-card-title">Cancelled (Today)</div>
          <i className="fas fa-times-circle stat-card-icon"></i>
        </div>
        <div className="stat-card-value">
          {dashboardData.overview.todayCancelledOrders}
        </div>
        <div className="stat-card-footer">
          <span>Total</span>
          <span className="change negative">
            {dashboardData.overview.cancelledOrders}
          </span>
        </div>
      </div>

      {/* 5. Opening Amount Card */}
      <div
        className="stat-card"
        style={{ borderLeftColor: "var(--info-color)" }}
      >
        <div className="stat-card-header">
          <div className="stat-card-title">Opening Amount (Today)</div>
          <i className="fas fa-utensils stat-card-icon"></i>
        </div>
        <div className="stat-card-value">
          ₹{dashboardData.overview.combinedOpeningAmount || 0}
        </div>
      </div>

      {/* 6. Closing Amount Card */}
      <div
        className="stat-card"
        style={{ borderLeftColor: "var(--info-color)" }}
      >
        <div className="stat-card-header">
          <div className="stat-card-title">Closing Amount (Today)</div>
          <i className="fas fa-utensils stat-card-icon"></i>
        </div>
        <div className="stat-card-value">
          ₹{dashboardData.overview.combinedClosingAmount || 0}
        </div>
      </div>
    </div>
  );
}
